module.exports = __webpack_public_path__ + "84a3dbc2eb93d94950c63c89defaaadf.pdf";